import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";
import { getServerMessage } from "./sendMessage";

export const resendMessage = ({ churchId, messageId }) => {
  return axios.get(`/churches/${churchId}/send-message/${messageId}`);
};

export const useResendMessage = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;

  return useMutation({
    onSuccess: data => {
      if (data?.status === false) {
        setNotification({ type: "error", message: getServerMessage(data) });
        return;
      }
      queryClient.invalidateQueries("messages");
      queryClient.invalidateQueries("send-messages");
      queryClient.invalidateQueries(["church"]); // refresh sms_used
      setNotification({
        type: "success",
        message: "Message sent successfully"
      });
    },
    onError: error => {
      setNotification({ type: "error", message: getServerMessage(error) });
    },
    ...config,
    mutationFn: resendMessage
  });
};
